<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'App',
    mounted() {
        const navigatorObject = require('@/lib/common')
        const commonMethods = navigatorObject.default(function(doc, win) {
            var docEl = doc.documentElement
            var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
            var recalc = function() {
                var clientWidth = docEl.clientWidth
                if (!clientWidth) return
                if (commonMethods._isMobile() && !commonMethods._isPc()) {
                    docEl.style.fontSize = 16 * (clientWidth / 750) + 'px'
                } else {
                    if (clientWidth <= 1240) {
                        docEl.style.fontSize = 16 * (1240 / 1904) + 'px'
                    } else {
                        docEl.style.fontSize = 16 * (clientWidth / 1904) + 'px'
                    }
                }
            }

            if (!doc.addEventListener) return
            win.addEventListener(resizeEvt, recalc, false)
            doc.addEventListener('DOMContentLoaded', recalc, false)
        })(document, window)
    }
}
</script>



// WEBPACK FOOTER //
// src/App.vue